<template>
  <div class="workshop-card" @click="$emit('girar')">
    
    <div class="front" :class="{ 'flipped-active': isFlipped }"
      :style="{ backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 60%), url(${workshop.imagenSrc})` }">
      <h3>{{ workshop.nombre }}</h3>
    </div>

    <div class="back" :class="{ 'flipped-active': isFlipped }">
      <h3>{{ workshop.nombre }}</h3>
      <p>{{ workshop.descripcion }}</p>
      <p>{{ workshop.beneficio }}</p>
    </div>

  </div>
</template>

<script>
export default {
  props: ["workshop"],
};
</script>

<style lang="scss" scoped>
.workshop-card {
  width: 350px;
  height: 350px;
  position: relative;
  perspective: 1000px;
  cursor: pointer;
}


.front, .back {
  width: 100%;
  height: 100%;
  border-radius: 14px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  backface-visibility: hidden;
  transition: transform 0.6s ease;
}


.front {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  
  display: flex;
  flex-direction: column;
  justify-content: flex-end; 
  align-items: center;       
  
  color: white;
  padding: 10px;
  box-sizing: border-box; 
  position: relative;   
  z-index: 2; 
  transition: transform  .8s;
}

.front h3 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.8);
  position: relative;
  z-index: 3;
}


.back {
  background: white;
  color: #333;
  transform: rotateY(180deg);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  align-items: center;
  text-align: center;
  transition: transform 0.6s ease;

  h3 {
    margin: 0 15px 10px 15px;
    font-size: 20px;
    font-weight: 700;
    color: #b20000;
  }
  p {
    margin: 5px 15px;
    font-size: 18px;
  }
}


.workshop-card:hover .front {
  transform: rotateY(-180deg);
}

.workshop-card:hover .back {
  transform: rotateY(0deg);
}
</style>

